import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import  Axios  from "../../utils/axios"

export const brandList = createAsyncThunk("medicine/brandList", async ({rejectWithValue}) => {
    try{
      const response = await Axios.get(`/api/brands-data`);
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
});

export const medicineList = createAsyncThunk("medicine/medicineList", async ({ search, brands, page, perPage},{rejectWithValue}) => {
    try{
      const response = await Axios.get(`/api/medicines`,{ params: {search, brands, page, perPage}});
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
});

export const reqToMedicineDetail = createAsyncThunk("medicine/reqToMedicineDetail", async ({id},{rejectWithValue}) => {
  try{
    const response = await Axios.get(`/api/medicines/${id}`);
    return response.data;
  }catch(error){
    return rejectWithValue(error.response.data);
  }
});


const medicineSlice = createSlice({
    name:"medicine",
    initialState:{
        error:null,
        isLoading:false,
        brands:[],
        medicine:[],
        medicineDetail:{}
    },
    reducer:{},
    extraReducers:(builder)=>{
        builder
        // Req to Get List of BrANDS
        .addCase(brandList.fulfilled, (state,action) => {
            state.isLoading = false;
            state.brands = action.payload
        })
        // Req to Get List of Medicines
        .addCase(medicineList.fulfilled, (state,action) => {
            state.isLoading = false;
            state.medicine = action.payload
        })
        //  Req to Get Medicine Detail
         .addCase(reqToMedicineDetail.fulfilled, (state,action) => {
          state.isLoading = false;
          state.medicineDetail = action.payload
      })
    }
})

export default medicineSlice.reducer;